import { render } from "./PurchasingHelp.vue?vue&type=template&id=41158e71"
import script from "./PurchasingHelp.vue?vue&type=script&lang=js"
export * from "./PurchasingHelp.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__